const TRACE_PREFIX = "[CATCH_TX]";
const REFRESH_EVENT = "catchSubmitRefresh";

const gateState = {
  isCatchModalActive: false,
  isCatchSubmitActive: false,
  activeAttemptId: null,
  lastAttemptId: null,
  pendingRefresh: null,
};

const logCatchTx = (event, details = {}) => {
  try {
    console.warn(TRACE_PREFIX, event, details);
  } catch {
    // no-op
  }
};

const shouldBlock = () => gateState.isCatchModalActive || gateState.isCatchSubmitActive;

const getBlockReason = () =>
  gateState.isCatchSubmitActive
    ? "submit"
    : gateState.isCatchModalActive
      ? "modal"
      : "";

const dispatchRefresh = (detail) => {
  if (typeof window === "undefined") {
    return;
  }
  window.dispatchEvent(new CustomEvent(REFRESH_EVENT, { detail }));
};

const flushPendingRefresh = () => {
  if (shouldBlock() || !gateState.pendingRefresh) {
    return;
  }
  const pending = gateState.pendingRefresh;
  gateState.pendingRefresh = null;
  dispatchRefresh(pending);
};

export const setCatchModalActive = (active, meta = {}) => {
  const nextValue = Boolean(active);
  if (gateState.isCatchModalActive === nextValue) {
    return;
  }

  gateState.isCatchModalActive = nextValue;
  if (nextValue) {
    gateState.lastAttemptId = null;
  } else {
    logCatchTx("modal_close", {
      attemptId:
        meta.attemptId ??
        gateState.activeAttemptId ??
        gateState.lastAttemptId ??
        null,
      reason: meta.reason || "",
    });
  }
  flushPendingRefresh();
};

export const setCatchSubmitActive = (active, meta = {}) => {
  const nextValue = Boolean(active);
  if (gateState.isCatchSubmitActive === nextValue) {
    return;
  }

  gateState.isCatchSubmitActive = nextValue;
  if (nextValue) {
    const nextAttemptId = meta.attemptId ?? null;
    gateState.activeAttemptId = nextAttemptId;
    if (nextAttemptId != null) {
      gateState.lastAttemptId = nextAttemptId;
    }
  } else {
    gateState.activeAttemptId = null;
  }
  flushPendingRefresh();
};

export const getCatchSubmitGateSnapshot = () => ({
  isCatchModalActive: gateState.isCatchModalActive,
  isCatchSubmitActive: gateState.isCatchSubmitActive,
});

export const shouldBlockBackgroundRefresh = () => shouldBlock();

export const reportBackgroundRefreshBlocked = ({ source, attemptId } = {}) => {
  const reason = getBlockReason();
  if (!reason) {
    return false;
  }

  void source;
  void attemptId;
  return true;
};

export const requestCatchSubmitRefresh = (detail = {}) => {
  const attemptId = detail?.attemptId ?? gateState.activeAttemptId ?? gateState.lastAttemptId ?? null;
  if (shouldBlock()) {
    gateState.pendingRefresh = {
      ...detail,
      queuedAt: Date.now(),
    };
    logCatchTx("refresh_queued", {
      attemptId,
      reason: getBlockReason(),
      queued: true,
    });
    return false;
  }

  logCatchTx("refresh_queued", {
    attemptId,
    reason: "",
    queued: false,
  });
  dispatchRefresh(detail);
  return true;
};

export const getCatchSubmitRefreshEventName = () => REFRESH_EVENT;
